(function() {
  'use strict';
  
  function initNightCitySwiper() {
    if (typeof Swiper === 'undefined') {
      console.log('[NCG Night City] Swiper not loaded, retrying...');
      setTimeout(initNightCitySwiper, 500);
      return;
    }
    
    var container = document.querySelector('.ncg-night-city-banner__swiper');
    if (!container) return;
    if (container.classList.contains('swiper-initialized')) return;
    
    var swiper = new Swiper(container, {
      slideClass: 'ncg-night-city-banner__slide',
      wrapperClass: 'ncg-night-city-banner__wrapper',
      
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 600,
      autoplay: false,
      
      navigation: {
        nextEl: '.ncg-night-city-banner__arrow--next',
        prevEl: '.ncg-night-city-banner__arrow--prev',
        disabledClass: 'ncg-night-city-banner__arrow--disabled',
        hiddenClass: 'ncg-night-city-banner__arrow--hidden'
      },
      
      on: {
        init: function() {
          updatePagination(this);
          fixPointerEvents(this);
        },
        slideChangeTransitionEnd: function() {
          updatePagination(this);
          fixPointerEvents(this);
        }
      },
      
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}'
      }
    });
    
    function updatePagination(swiperInstance) {
      var paginationEl = document.querySelector('.ncg-night-city-banner__pagination');
      if (paginationEl) {
        var current = swiperInstance.realIndex + 1;
        
        var total = 0;
        for (var i = 0; i < swiperInstance.slides.length; i++) {
          if (!swiperInstance.slides[i].classList.contains('swiper-slide-duplicate')) {
            total++;
          }
        }
        
        paginationEl.textContent = current + '/' + total;
      }
    }
    
    function fixPointerEvents(swiperInstance) {
      var slides = swiperInstance.slides;
      var activeIndex = swiperInstance.activeIndex;
      
      
      slides.forEach(function(slide, index) {
        if (index === activeIndex) {
          slide.style.pointerEvents = 'auto';
          slide.style.zIndex = '2';
          slide.classList.add('ncg-night-city-banner__slide-active');
        } else {
          slide.style.pointerEvents = 'none';
          slide.style.zIndex = '1';
          slide.classList.remove('ncg-night-city-banner__slide-active');
        }
      });
    }
    
    window.ncgNightCitySwiper = swiper;
    container.classList.add('swiper-initialized');
    console.log('[NCG Night City] Swiper initialized');
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNightCitySwiper);
  } else {
    initNightCitySwiper();
  }
})();